module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/asignacion-manual-sede/asignacion-manual-sede.component.css
// module id = ./src/app/asignacion-manual-sede/asignacion-manual-sede.component.css
// module chunks = main